import { Component, OnInit, Optional } from '@angular/core';

import { Controllers } from '@shared/core/controllers';
import * as Services from '@shared/core/services';

import { Observable } from 'rxjs';

@Component({
    selector: 'shared-account-member-hero-header',
    templateUrl: './account-member-hero-header.shared.component.html',
    styleUrls: ['./account-member-hero-header.shared.component.scss']
})
export class AccountMemberHeroHeaderComponent implements OnInit {
    public btnSize: OLO.Components.BUTTON_SIZE = 'lg';

    public memberFullName$!: Observable<string>;
    public hasLoyaltyCard$!: Observable<boolean>;
    public showMemberCardNumber$!: Observable<boolean>;
    public memberCardNumber$!: Observable<string>;

    constructor(
        public controllers: Controllers,
    ) { }

    ngOnInit(): void {
        this.memberFullName$ = this.controllers.members.getMemberFullName$();
        this.hasLoyaltyCard$ = this.controllers.loyalty.currentMemberHasLoyaltyCard$();
        this.showMemberCardNumber$ = this.controllers.members.showMemberCardNumber$();
        this.memberCardNumber$ = this.controllers.members.memberCardNumber$();
    }

    public handleSignOut($event: Event): void {
        this.controllers.members.signOut('/', true);
    }

    public handleOpenCardClick($event: Event): void {
        this.controllers.loyalty.showMemberCardCode();
    }

    public get isCenter(): boolean {
        return window.innerWidth < 768;
    }
}
